import { client } from '@/common-utils/libraries/axios/axios';
import { ENVELOPES } from '../apiUrls';
const mutationCreateEnvelope = (onSuccess, onError) => {
    return {
        mutationFn: ({ envelopeDataToSend }) => {
            return client.post(ENVELOPES.CREATE.url, envelopeDataToSend);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationCreateEnvelope;